import { createSlice } from '@reduxjs/toolkit';

export const financialConfigurationsSlice = createSlice({
    name: 'financialConfigurations',
    initialState: {
        financialConfiguration: null
    },

    reducers: {
        setFinancialConfiguration(state, action) {
            state.financialConfiguration = action.payload;
        },
    },
});

export const getFinancialConfiguration = state => state.financialConfigurations.financialConfiguration;
export const {
    setFinancialConfiguration
} = financialConfigurationsSlice.actions;

export default financialConfigurationsSlice.reducer;


